import { render, staticRenderFns } from "./ExamThemeTitle.vue?vue&type=template&id=1caa5fa6&scoped=true&"
import script from "./ExamThemeTitle.vue?vue&type=script&lang=js&"
export * from "./ExamThemeTitle.vue?vue&type=script&lang=js&"
import style0 from "./ExamThemeTitle.vue?vue&type=style&index=0&id=1caa5fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa5fa6",
  null
  
)

export default component.exports